const {Pushes} = require("./pushes");

$(document).ready(function () {
    $('[data-js-action="cancel_all_orders"]').click(function () {
        if (!confirm($(this).data('confirm-text'))) {
            return false;
        }

        const url = '/grid/' + $(this).data('id') + '/cancel_all_orders';

        $.ajax({
            url: url,
            type: 'GET',
            dataType: "json",
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                new Pushes(data).show();
            }
        });
    });

    $('#switchSymbol').change(function () {
        $('.switchable').toggleClass('visually-hidden');
    });



    $('#useManual').change(function () {
        const id = $(this).data('id');
        const data = {
            use_manual: $(this).prop('checked')
        };

        $.ajax({
            url : '/user_grids/use_manual/' + id,
            data: data,
            type: 'POST',
            dataType : "json",
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                new Pushes(data).show();
            }
        });
    });
});



